import warning from 'warning';

export default (condition: any, format?: string, ...extra: any[]) =>
  warning(condition, `[Window Messenger] ${format}`, ...extra);
